/* eslint-disable max-len */

import links, { getLinkWithParams } from 'links'

// Deck of Scarlet

import bannerDesktop from '../images/deck-of-scarlet/banner-desktop.jpg'
import bannerMobile from '../images/deck-of-scarlet/banner-mobile.jpg'

import assets0 from '../images/deck-of-scarlet/assets-0.jpg'
import bottomDesktop from '../images/deck-of-scarlet/bottom-desktop.jpg'
import bottomMobile from '../images/deck-of-scarlet/bottom-mobile.jpg'
import heroDesktop from '../images/deck-of-scarlet/hero-desktop.jpg'
import heroMobile from '../images/deck-of-scarlet/hero-mobile.jpg'
import logo from '../images/deck-of-scarlet/logo.svg'
import media0 from '../images/deck-of-scarlet/media-0.jpg'
import missionStatementDesktop from '../images/deck-of-scarlet/mission-statement-desktop.jpg'
import missionStatementMobile from '../images/deck-of-scarlet/mission-statement-mobile.jpg'

import navigationBackground from '../images/deck-of-scarlet/navigation-background.jpg'
import navigationLogo from '../images/deck-of-scarlet/navigation-logo.svg'

import modalHeroDesktop from '../images/deck-of-scarlet/modal-hero-desktop.jpg'
import modalHeroMobile from '../images/deck-of-scarlet/modal-hero-mobile.jpg'
import modalLogo from '../images/deck-of-scarlet/modal-logo.svg'


const featuredBrandData: BrandsModule.FeaturedBrandData = {
  bannerData: {
    image: {
      desktop: bannerDesktop,
      mobile: bannerMobile,
    },
    name: 'Deck of Scarlet',
    text: {
      desktop: 'More is always more, and between the luxe, decadent fragrances and clean, vegan\nformulations, Deck of Scarlet\'s scents are doing the most.',
      mobile: 'More is always more, and between the luxe, decadent fragrances and clean, vegan formulations, Deck of Scarlet\'s scents are doing the most.',
    },
    title: 'Deck of Scarlet',
    to: getLinkWithParams(links.brand, { name: 'deck-of-scarlet' }),
  },
  featuredBrandInfo: {
    assets: [ { url: assets0, type: 'image' } ],
    bottom: {
      image: {
        desktop: bottomDesktop,
        mobile: bottomMobile,
      },
    },
    country: 'New York City',
    description: 'Deck of Scarlet is on a mission to break the clean category, redefining what clean fragrances should smell like. Composed entirely of vegan, cruelty-free ingredients, our fragrances bridge the gap between the clean and luxury categories, using the highest eau de parfum concentrations housed in sculptural, eye-catching bottles. You shouldn\'t have to choose between being luxe and refined, or clean and vegan—now, you don\'t have to.',
    groupFragrances: true,
    hero: {
      desktop: heroDesktop,
      mobile: heroMobile,
    },
    largeLogo: true,
    logo: logo,
    medias: [ { url: media0, type: 'image' } ],
    missionStatement: {
      image: {
        desktop: missionStatementDesktop,
        mobile: missionStatementMobile,
      },
      supTitle: 'Why Scarlet?',
      text: 'Arguably one of the boldest colors of the spectrum, Scarlet makes a statement without saying a word. It represents courage, passion, and a call to action. It\'s unapologetically bold, loud, and daring. It\'s the color of revolution and empowerment. It\'s everything we think fragrance should be.<br /><br />Most of all – it embodies how we want you to feel about yourself when you wear our scents, our take on fragrance, and the spirit of our brand.',
      textStyle: 'sh5',
    },
    productIds: [ 2432, 2202, 2518, 2519 ],
    quote: {
      authorName: 'Mariya Nurislamova',
      authorPosition: 'CEO',
      supTitle: 'Our love language',
      text: 'Who says you have to choose between clean formulations and luxe, decadent fragrances? Our love language is everything, and Deck of Scarlet fragrances allow you to have it all.',
    },
    year: 0,
  },
  modalData: {
    image: {
      desktop: modalHeroDesktop,
      mobile: modalHeroMobile,
    },
    largeLogo: true,
    logo: modalLogo,
    name: 'Deck of Scarlet',
    productIds: {
      FEMALE: [ '2432', '2202', '2518', '2519' ],
      MALE: [ '2432', '2202', '2518', '2519' ],
    },
    text: {
      desktop: 'More is always more, and Deck of Scarlet is<br />fusing luxurious, decadent scents with clean,<br />vegan formulations.',
      mobile: '',
    },
    textColor: {
      desktop: 'white',
      mobile: null,
    },
    to: getLinkWithParams(links.brand, { name: 'deck-of-scarlet' }),
  },
  modalOptions: {
    genders: [ 'FEMALE' ],
  },
  navigationBannerData: {
    background: navigationBackground,
    logo: navigationLogo,
    name: 'Deck of Scarlet',
    text: 'Who says you have to choose\nbetween clean formulations and\nluxe, decadent fragrances? Thanks\nto Deck of Scarlet, you can have\nboth—and then some.',
    textColor: 'white',
    to: getLinkWithParams(links.brand, { name: 'deck-of-scarlet' }),
  },
}

export default featuredBrandData
